"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.TitlesDefaultCompact = void 0;
require("./TitlesDefaultCompact.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * TitlesDefaultCompact component
 *
 * @method
 * @param { TitlesDefaultCompactProps} props
 * @returns TitlesDefaultCompact
 */

const TitlesDefaultCompact = props => {
  const {
    countLabel,
    externalAction,
    headline,
    headlineTag = defaultProps.headlineTag,
    description,
    linkAction,
    subheadline,
    textAlignment,
    textColor = defaultProps.textColor
  } = props;
  if (!headline) {
    return null;
  }
  const hasAction = linkAction?.label || externalAction;
  const headlineStyle = textAlignment === 'center' ? 'title' : 'title-sm';
  const subHeadlineStyle = textAlignment === 'center' ? 'body-lg' : 'body';
  const descriptionTextColor = textColor === 'content-default' ? 'xsubtle' : textColor;
  const componentClassName = (0, _classnames.default)('pal-c-TitlesDefaultCompact', {
    [`pal-c-TitlesDefaultCompact__alignment--${textAlignment}`]: textAlignment,
    'pal-c-TitlesDefaultCompact__hasActions': hasAction
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefaultCompact__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefaultCompact__content--headline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: headlineStyle,
    htmlTag: headlineTag,
    textAlign: textAlignment,
    textColor: textColor
  }, headline), countLabel && /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: "pal-c-TitlesDefaultCompact__content--countLabel",
    textStyle: subHeadlineStyle,
    htmlTag: "span",
    textAlign: textAlignment,
    textColor: descriptionTextColor
  }, countLabel)), subheadline && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: subHeadlineStyle,
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: textColor,
    className: "pal-c-TitlesDefaultCompact__content--subheadline"
  }, subheadline), description && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: subHeadlineStyle,
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: descriptionTextColor,
    className: "pal-c-TitlesDefaultCompact__content--description"
  }, description)), hasAction && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefaultCompact__link"
  }, externalAction && (0, _renderObject.renderObject)(externalAction), !externalAction && /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    variant: "primary"
  }, linkAction))));
};

/**
 * Property type definitions
 * @typedef TitlesDefaultCompactProps
 * @type {object}
 * @property {string} countLabel - Accepts count label
 * @property {object} externalAction - Accepts action object from web-site with business logic
 * @property {string} headline - Sets the headline text of the title
 * @property {string} headlineTag - Sets the headline text's tag
 * @property {object} linkAction - Accepts an object to render palette Link component as action. ( Palette use only )
 * @property {string} subheadline - Sets the subheadline text of the title
 * @property {string} description - Accepts description text to render below subheadline
 * @property {string} textAlignment - Sets the alignment of the title ( left or center )
 * @property {string} size - Sets the size of the overall component
 * @property {string} textColor - Sets the color of the title
 */
exports.TitlesDefaultCompact = TitlesDefaultCompact;
const propTypes = exports.propTypes = {
  /**
     * Accepts count label
     */
  countLabel: _propTypes.default.string,
  /**
   * Accepts action object from web-site with business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Sets the headline text of the title
   */
  headline: _propTypes.default.string,
  /**
   * Sets the headline text's tag
   */
  headlineTag: _propTypes.default.string,
  /**
   * Accepts an object to render palette Link component as action. ( Palette use only )
   */
  linkAction: _propTypes.default.object,
  /**
   * Sets the subheadline text of the title
   */
  subheadline: _propTypes.default.string,
  /**
   * Accepts description text to render below subheadline
   */
  description: _propTypes.default.string,
  /**
   * Sets the alignment of the title ( left or center )
   */
  textAlignment: _propTypes.default.string,
  /**
   * Sets the color of the title
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag='h2' - sets default headline tag to h2.
 * @property {string} textColor='content-default' - sets default text color of the title to content-default
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2',
  textColor: 'content-default'
};
TitlesDefaultCompact.propTypes = propTypes;
var _default = exports.default = TitlesDefaultCompact;